// 时间戳转换成日期:
function checkNum(m: number) {
  return m < 10 ? '0' + m : m
}


export function formatStampTime(stampTime: number) {
  let time
  if (String(stampTime).length === 10) {
    time = new Date(stampTime * 1000)
  } else {
    time = new Date(stampTime)
  }
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let date = time.getDate()
  let hour = time.getHours()
  let minute = time.getMinutes()
  let second = time.getSeconds()
  return year + '-' + checkNum(month) + '-' + checkNum(date) + ' ' + checkNum(hour)
  + ':' + checkNum(minute) + ':' + checkNum(second)
}

export function formatStampToDate(stampTime: number) {
  const time = new Date(stampTime * 1000)
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let date = time.getDate()
  return year + '-' + checkNum(month) + '-' + checkNum(date)
}

export function formatStampNoDate(stampTime: number) {
  const time = new Date(stampTime * 1000)
  let hour = time.getHours()
  let minute = time.getMinutes()
  return checkNum(hour) + ':' + checkNum(minute)
}

export function formatStampToDateString(stampTime: number) {
  const time = new Date(stampTime * 1000)
  let year = time.getFullYear()
  let month = time.getMonth() + 1
  let date = time.getDate()
  return year + '年' + checkNum(month) + '月' + checkNum(date) + '日'
}

// 处理传过来的position数据：
export function transformValue(arr: any, val: any) {
  let text: string = ''
  arr.forEach( (item: any, index: number) =>  {
    if (item.value === val) {
      text = item.label
    }
  })
  return text
}

// 分钟 => 小时
export function transformMinute(val: number) {
  const value = Number(val)
  if (value < 1) {
    return '不足一分钟'
  }
  if (value < 60) {
    return `${value}分钟`
  }
  const hour = Math.floor(value / 60)
  const minute = value % 60
  if (hour < 24) {
    return `${hour}小时${minute}分钟`
  } else {
    const day = Math.floor(hour / 24)
    const hour2 = hour % 24
    return `${day}天${hour2}小时${minute}分钟`
  }
}
